module.exports = __webpack_public_path__ + "img/sms_inactive.d8ecd442.svg";